import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { ProductsProvider } from "@/context/ProductsContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import ShopPage from "@/pages/ShopPage";
import AdminPage from "@/pages/AdminPage";
import PosPage from "@/pages/PosPage";
import PrintStickers from "@/pages/PrintStickers";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15, smoothWheel: true });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ProductsProvider>
          <CartProvider>
            <ScrollToTop />
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/bling" element={<ShopPage slug="bling" />} />
              <Route path="/glow" element={<ShopPage slug="glow" />} />
              <Route path="/lemonade" element={<ShopPage slug="lemonade" />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/pos" element={<PosPage />} />
              <Route path="/print/:orderId" element={<PrintStickers />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <CartDrawer />
            <Toaster theme="dark" position="bottom-right" />
          </CartProvider>
        </ProductsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
